import React, { useState } from 'react';
import { useContent } from '../hooks/useContent';
import './Contacts.css';

const CHAIRMAN_IMAGE = 'https://fincenter.kz/assets/manuals1-4ee5a24c.jpg';

const ContactInfo = ({ icon, text }) => (
  <div className="ct-row">
    <span className="ct-ico">{icon}</span>
    <div className="ct-txt">{text}</div>
  </div>
);

function AppealModal({ onClose, ui }) {
  const c = ui.contacts;
  const ap = c.appeal;
  const [category, setCategory] = useState(c.categories[0]);
  const [desc, setDesc] = useState('');
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (desc.trim().length >= 25) setSubmitted(true);
  };

  return (
    <div className="appeal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="appeal-modal">
        <button className="appeal-modal__close" onClick={onClose} aria-label={ui.common.close}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>

        {submitted ? (
          <div className="appeal-modal__success">
            <div className="f-ok-ico"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg></div>
            <div className="f-ok-t">{ap.successTitle}</div>
            <div className="f-ok-s">{ap.successSub}</div>
            <button className="appeal-modal__submit" onClick={onClose} style={{marginTop: 20}}>{ui.common.close}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 className="appeal-modal__title">{ap.title}</h2>

            <div className="appeal-modal__field">
              <label className="appeal-modal__label">{ap.category}</label>
              <select className="appeal-modal__select" value={category} onChange={e => setCategory(e.target.value)}>
                {c.categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
              </select>
            </div>

            <div className="appeal-modal__field">
              <label className="appeal-modal__label">{ap.description}</label>
              <textarea
                className="appeal-modal__textarea"
                placeholder={ap.descPlaceholder}
                value={desc}
                onChange={e => setDesc(e.target.value)}
                rows={5}
              />
              <div className="appeal-modal__counter" style={{color: desc.trim().length < 25 ? '#3b6fd4' : '#16a34a'}}>
                {desc.trim().length} {ap.chars}
              </div>
            </div>

            <div className="appeal-modal__name-row">
              <div className="appeal-modal__field">
                <label className="appeal-modal__label">{ap.lastName}</label>
                <input className="appeal-modal__input" placeholder={ap.lastName} value={lastName} onChange={e => setLastName(e.target.value)} />
              </div>
              <div className="appeal-modal__field">
                <label className="appeal-modal__label">{ap.firstName}</label>
                <input className="appeal-modal__input" placeholder={ap.firstName} value={firstName} onChange={e => setFirstName(e.target.value)} />
              </div>
            </div>

            <div className="appeal-modal__field">
              <label className="appeal-modal__label">{ap.patronymic}</label>
              <input className="appeal-modal__input" style={{maxWidth: '48%'}} placeholder={ap.patronymicShort} value={patronymic} onChange={e => setPatronymic(e.target.value)} />
            </div>

            <button
              type="submit"
              className="appeal-modal__submit"
              disabled={desc.trim().length < 25}
            >
              {ap.submit}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const Contacts = () => {
  const { ui } = useContent();
  const c = ui.contacts;
  const f = c.form;

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [agree, setAgree] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setSubmitted] = useState(false);
  const [showAppealModal, setShowAppealModal] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = f.errName;
    if (!phone.trim() || phone.trim().length < 6) newErrors.phone = f.errPhone;
    if (!agree) newErrors.agree = f.errAgree;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) setSubmitted(true);
  };

  return (
    <section id="contacts">
      <div className="section">
        <div className="section-label">{c.label}</div>
        <h2 className="section-title">{c.title}<br/><em>{c.titleEm}</em></h2>
        <p className="section-subtitle" style={{maxWidth: '760px'}}>{c.subtitle}</p>

        <div className="ct-grid" style={{marginTop: 40}}>
          <div className="ct-left">
            <div className="ct-chairman">
              <div className="ct-chairman__hero">
                <img src={CHAIRMAN_IMAGE} alt={c.chairman.name} className="ct-chairman__img" />
                <div className="ct-chairman__overlay" />
                <div className="ct-chairman__person">
                  <div className="ct-chairman__role">{c.chairman.role}</div>
                  <div className="ct-chairman__name">{c.chairman.name}</div>
                </div>
              </div>
            </div>

            <h2 className="ct-h">{c.formTitle}<br/>{c.titleEm}</h2>
            <p className="ct-sub">{c.formSubtitle}</p>
            <ContactInfo icon={<svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>} text={c.address} />
            <ContactInfo
              icon={<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.19 12a19.79 19.79 0 0 1-1.07-3.82A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>}
              text={<>+7 (7172) 69-50-60<br/>+7 (800) 080-28-28 {c.phoneFree}</>}
            />
            <ContactInfo icon={<svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>} text="info@fincenter.kz" />
            <ContactInfo icon={<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>} text={c.hours} />
          </div>

          <div className="ct-right">
            {!isSubmitted ? (
              <div id="ctForm">
                <h3 className="f-h">{c.writeUs}</h3>
                <div className="f-row">
                  <div className="f-g" style={{marginBottom:0}}>
                    <label className="f-lbl">{f.nameLabel}</label>
                    <input type="text" className={`f-inp ${errors.name ? 'err' : ''}`} value={name} onChange={e => setName(e.target.value)} placeholder={f.namePlaceholder}/>
                    {errors.name && <div className="f-er show">{errors.name}</div>}
                  </div>
                  <div className="f-g" style={{marginBottom:0}}>
                    <label className="f-lbl">{f.phoneLabel}</label>
                    <input type="tel" className={`f-inp ${errors.phone ? 'err' : ''}`} value={phone} onChange={e => setPhone(e.target.value)} placeholder={f.phonePlaceholder}/>
                    {errors.phone && <div className="f-er show">{errors.phone}</div>}
                  </div>
                </div>
                <div className="f-g">
                  <label className="f-lbl">{f.emailLabel}</label>
                  <input type="email" className="f-inp" placeholder={f.emailPlaceholder}/>
                </div>
                <div className="f-g">
                  <label className="f-lbl">{f.messageLabel}</label>
                  <textarea className="f-ta" placeholder={f.messagePlaceholder}></textarea>
                </div>
                <div className="f-chk">
                  <input type="checkbox" id="f-agree" checked={agree} onChange={e => setAgree(e.target.checked)}/>
                  <label htmlFor="f-agree">{f.agreeLabel}</label>
                </div>
                <button className="btn-primary" type="button" onClick={handleSubmit} style={{width:'fit-content'}}>
                  {c.appealBtn}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M22 2L11 13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                </button>

                <div className="ct-appeal-block">
                  <div className="ct-appeal-block__btns">
                    <a
                      href="https://dialog.egov.kz/blogs/2883586/questions"
                      target="_blank"
                      rel="noreferrer"
                      className="chairman-blog__action-btn--outline ct-appeal-block__btn"
                    >
                      {c.openDialog}
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div className="f-ok show">
                <div className="f-ok-ico"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg></div>
                <div className="f-ok-t">{f.thanksTitle}</div>
                <div className="f-ok-s">{f.thanksSub}</div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAppealModal && <AppealModal onClose={() => setShowAppealModal(false)} ui={ui} />}
    </section>
  );
};

export default Contacts;
